import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';

// Define custom styles type
type CustomStyles = {
    borderRadius?: string;
    backgroundColor?: string;
    boxShadow?: string;
    width?: string;
    height?: string;
    color?: string;
    borderColor?: string;
    hoverBorderColor?: string;
    outlineBorder?: string;
};

// Create a new type that combines TextField props with custom styles
type CustomNumberTextFieldProps = TextFieldProps & {
    customStyles?: CustomStyles;
};

const CustomNumberTextField = styled(TextField)<CustomNumberTextFieldProps>(
    ({ customStyles }) => ({
        '& .MuiOutlinedInput-root': {
            borderRadius: customStyles?.borderRadius || '5px',
            backgroundColor: customStyles?.backgroundColor || 'rgba(255, 255, 255, 0.4)',
            boxShadow: customStyles?.boxShadow || '0 2px 4px rgba(0, 0, 0, 0.2)',
            width: customStyles?.width || '100px',
            height: customStyles?.height || '40px',
            color: customStyles?.color || '#fff',
            fontSize: '18px',
            fontWeight: '500',

            '& fieldset': {
                borderColor: customStyles?.borderColor || 'transparent',
            },

            '&:hover fieldset': {
                borderColor: customStyles?.hoverBorderColor || 'transparent',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: customStyles?.outlineBorder || 'none',
        },
        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
            opacity: 1,
            background: 'transparent',
            cursor: 'pointer',
        },
    })
);

export default CustomNumberTextField;